import Vue from "vue";
import Vuex from "vuex";

import CorporateModule from "./corporate_module";
import PackageModule from "./package_module";
import PilotNumberModule from "./pilot_number_module";
import AgentNumberModule from "./agent_number_module";
import MappingNumberModule from "./mapping_number_module";
import VoicemailModule from "./voicemail_module";
import CdrModule from "./cdr_module";
import AuthModule from "./auth_module";
import MlhgModule from "./mlhg_module";
import ReportModule from "./report_module";
import MlhgNumberModule from "./mlhg_number_module";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const modules = {
  Corporate: CorporateModule,
  Package: PackageModule,
  PilotNumber: PilotNumberModule,
  AgentNumber: AgentNumberModule,
  MappingNumber: MappingNumberModule,
  Voicemail: VoicemailModule,
  Cdr: CdrModule,
  Mlhg: MlhgModule,
  MlhgNumber: MlhgNumberModule,
  Auth: AuthModule,
  Report: ReportModule
};

export default new Vuex.Store({
  modules,
  plugins: [
    createPersistedState({
      paths: ["Auth"]
    })
  ]
});
